import { UpdateItemBlockModel } from "../../../../api/repositories/stats/models/updates"
import { localize } from "../../../../common/services/localization"
import { ItemUpdateImage } from "../../ui/file-contents"
import { LocalizeInnerHtml, LocalizeListElement, LocalizeUpdateChange } from "../../ui/other"

export const UpdateItemsBlock: React.FC<{
    items: UpdateItemBlockModel[]
}> = ({ items }) => {
    return <div>
        {items.map((k, i) => <UpdateItemBlock
            key={i}
            item={k}
            isLast={i == items.length - 1}
        />)}
    </div>
}

const UpdateItemBlock: React.FC<{
    item: UpdateItemBlockModel
    isLast: boolean
}> = ({ item, isLast }) => {
    return <div className={`flex flex-col gap-[14px] py-[18px] ${!isLast && 'border-b-dark'}`}>
        <div className="flex flex-row gap-[16px] items-center text-[20px]">
            <ItemUpdateImage name={item.name} />
            <LocalizeUpdateChange changeType={item.changeType} />
        </div>
        <LocalizeInnerHtml
            ruRows={item.ruRows}
            engRows={item.engRows}
        />
    </div>
}